import { render, staticRenderFns } from "./BookQuickPreview.vue?vue&type=template&id=86945cda&scoped=true&"
import script from "./BookQuickPreview.vue?vue&type=script&lang=js&"
export * from "./BookQuickPreview.vue?vue&type=script&lang=js&"
import style0 from "./BookQuickPreview.vue?vue&type=style&index=0&id=86945cda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86945cda",
  null
  
)

export default component.exports